export default __webpack_public_path__ + "static/media/GOOGLEMAPS.50c263ac.png";